"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allEpics = void 0;
const redux_observable_1 = require("redux-observable");
const current_1 = require("./current");
const files_1 = require("./files");
const projects_1 = require("./projects");
const link_1 = require("./link");
const metas_1 = require("./metas");
const congridProjects_1 = require("./congridProjects");
const _folderTree = require("../../modules/files/tree/epics");
const folderTree = _folderTree.default('congrid');
exports.allEpics = redux_observable_1.combineEpics(
// Current
current_1.fetchCongridProject, 
// Files
files_1.fetchFiles, files_1.removeFile, 
// Projects
projects_1.fetchProjects, 
// Link
link_1.linkFiles, link_1.linkProjects, link_1.unlinkProjects, 
// Metas
metas_1.fetchMetas, 
// CONGRID PROJECTS
congridProjects_1.fetchProjects, folderTree.fetchTree);
//# sourceMappingURL=index.js.map